import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4z"
}), 'BookSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookSharp.js
// module id = 2391
// module chunks = 2